import {useMemo} from "react";
import {AppBtn} from "@/app/components/common/app-btn/AppBtn";
import * as React from "react";
import {Link, usePathname} from "@/i18n/navigation";

interface IProps {
    href: string;
    label: string;
}

export const AnchorLink = ({href, label}: IProps) => {
    const pathname = usePathname();

    const isActive = useMemo(() => pathname === href, [pathname, href]);

    return (
        <Link prefetch={false} href={href}>
            <AppBtn className={'text-left h-auto py-[10px]'} label={label} active={isActive}/>
        </Link>
    );
}
